import { useContext, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { ClientContext } from '../../context/ClientContext';
import { getCurrentUser } from '../../utils/jwtUtils';

/**
 * UserHydrator component that automatically loads user session on app startup
 * This ensures users with valid httpOnly cookies are automatically logged in
 */
const UserHydrator = ({ children }) => {
	const { state: authState, actions: { setUser } } = useContext(AuthContext);
	const { actions: { setClientFromUser } } = useContext(ClientContext);

	useEffect(() => {
		const hydrateUser = async () => {
			// Fetch user data if we don't have it yet
			if (!authState.user) {
				try {
					const user = await getCurrentUser();
					if (user) {
						setUser(user);
						// Extract and set client ID from user
						const clientId = user.ClientId || user.clientId;
						if (clientId) {
							setClientFromUser(clientId);
						}
					}
				} catch (error) {
					// Silent fail - user is not logged in or session expired
					console.debug('No valid user session found:', error.message);
				}
			}
		};

		hydrateUser();
	}, [authState.loggedIn]); // Re-run when login state changes

	return children;
};

export default UserHydrator;
